<template>
  <div class="practibox">
    <div class="returnn">
      <img src="../../../static/img2/fanhui2.png" alt="">
      <span @click="goBack" style="cursor:pointer;">返回</span>
    </div>
    <div class="Record_details">
      <img class="qian" src="../../../static/img2/11qian.png" alt="">
      <span class="medical_name">训练详情</span>
      <div class="Record_img">
        <img :src="imgurl+datas.thum" alt="">
      </div>
      <div class="Record_score">
        <div class="scorename">{{datas.subhead}}</div>
        <p class="score1">训练时间：{{datas.created_at}}</p>
        <div v-if="datas.learn_id==141">
          <p class="score2">第一模块用时：{{formatSeconds(datas.total_time)}}</p>
        </div>
        <div v-else>
          <p class="score2">用时：{{formatSeconds(datas.total_time)}}</p>
        </div>
        <p class="score3">评价：{{datas.evaluate==null?datas.evaluate:'无'}}</p>
        <p class="score4">错误：{{datas.mistake==null?datas.mistake:'无'}}</p>
        <p class="score5">得分模块名称：{{datas.subtitle}}</p>
        <div class='score7'>
          <img src="../../../static/img2/defeng.jpg" alt="">
          <div class="score6" :style="{ color: activeColor1}">{{colorscore}}</div>
        </div>

      </div>
    </div>
    <button class="daochu" @click="toGetPdf" style="width:80px;height:30px;position: absolute;top: 610px;left: 77%;background-color: #fff;border: 0;border-radius: 10px;">导出</button>
    <button class="daochu" v-if="type" @click="goopenlist" style="width:80px;height:30px;position: absolute;top: 610px;left: 72%;background-color: #fff;border: 0;border-radius: 10px;">问卷调查</button>
    <div class="tablelist" id="demo" style="width:100%;height:100%; margin-top: 41px;overflow: hidden;">
      <template v-if="detail_type">
        <div v-for="(image,val) in detail_image">
          <el-image :src="GLOBAL.BASE_URL+'/'+image" style="margin-left: 342px; width: 1229px;margin-top: 50px;"></el-image><br>
        </div>
      </template>
      <!-- <template v-else>
        <el-table :data="title_item" :show-header='false' highlight-current-row:false :row-class-name="tableRowClassNamee" style="width: 1216px;  margin:43px auto 0; ">
          <el-table-column v-for="(v,i) in title_item[0]" align="center" :key="i">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row[i] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template> -->
      <template>
        <!-- <el-table :data="currentdata" :show-header='false' :row-class-name="tableRowClassName" style="width: 1216px; height: 100%; margin:3px auto ; " highlight-current-row:false>
          <el-table-column align="center" v-for="(v,i) in tableDataa[0]" :key="i">
            <template slot-scope="scope">
              <span>{{ scope.row[i] }}</span>
            </template>
          </el-table-column>
        </el-table> -->
        <div class="box-tabs-ul" ref="exportElement">
          <div class="box-tabs-table-body">
            <div class="box-tabs-table">
              <div class="box-tabs-table-head">
                <div style="font-weight: 700;width: 70%;text-align: center;" :style="{ width: index==0?'55%':'15%'}" v-for="(item,index) in currentdata" :key="index">{{ item }}</div>
              </div>
              <div :class="index % 2==0?'warning-row':'success-row'" class="box-tabs-table-ul" v-for="(item,index) in tableDataa" v-if="index>0" :key="index">
                <el-tooltip v-for="(itembody,indexbody) in item" :key="indexbody" class="item" effect="dark" :content="itembody" placement="top-start" :disabled="itembody.length<=10">
                  <div style="width: 70%;font-size: .16rem;text-align: center;white-space: nowrap; overflow: hidden; text-overflow: ellipsis;cursor: pointer;" :style="{ width: indexbody==0?'55%':'15%'}">{{ itembody }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>

</template>

<script>
import htmlToPdf from '../../restful/htmlToPdf'
export default {
  name: 'practiceDetail',
  data() {
    return {
      type: false,
      modal: false,
      detail_type: false,
      datas: [],
      detail_image: [],
      loading: true,
      imgurl: 'http://www.univrlab.com/',
      tableDataa: [],
      colorscore: '',
      activeColor1: '',
      total: 0,
      currentdata: [],
      currentdatatwo: [],
      title_item: [],
    }
  },
  methods: {
    goopenlist() {
      this.$router.push({
        name: 'evaluate',
        query: {
          id: this.datas.learn_id,
        },
      })
    },
    //pdf
    toGetPdf() {
      window.scrollTo(0, 0)
      this.getPdf(this.title)
    },
    //pdf
    getPractice() {

      this.$http.getScoreDetail({ id: this.$route.query.id }).then((res) => {
        console.log(res.data, 'res.data')
        if (res.code !== 0) {
          this.datas = res.data
          if (this.datas.evalue == true) {
            this.type = true
          }
          this.colorscore = res.data.total_score
          if (this.colorscore < '60') {
            this.activeColor1 = '#ff3131'
          }
          if (this.colorscore >= '60') {
            this.activeColor1 = '#46baff'
          }
          if (this.colorscore >= '90') {
            this.activeColor1 = '#00ffcc'
          }
          var tableData = JSON.parse(res.data.detail)
          console.log(tableData, 'tableData')
          if (this.datas.learn_id == 13 || this.datas.learn_id == 33) {
            this.detail_image = tableData
            this.detail_type = true
          } else {
            const tableDatadcapy = JSON.parse(JSON.stringify(tableData))
            this.currentdata = tableDatadcapy[0]

            // tableDatadcapy.forEach
            let arrliat = []
            for (const key in tableDatadcapy) {
              // console.log('item[key]', item[key]) //值
              // console.log('key', key) //键
              arrliat.push(tableDatadcapy[key])
            }
            this.tableDataa = arrliat
            this.detail_type = false
            // this.title_item = JSON.parse(res.data.detail).slice(0, length + 1)
            console.log(
              arrliat,
              this.currentdata,
              this.title_item,
              'this.title_item'
            )
          }
          this.loading = false
        } else {
          this.$message.error(res.message)
        }
      })
    },

    tableRowClassName({ row, rowIndex }) {
      return 'warning-row'
    },
    tableRowClassNamee({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row3'
      }
      return ''
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true
      next(0)
    },
    goBack() {
      this.$router.push({
        path: '/ucenter/practices',
      })
    },
  },
  created() {
    this.getPractice()
  },
}
</script>
<style lang="less">
@import '../../../static/fonts/stylemain/style.less';
@media screen and (max-width: 768px) {
  .practibox {
    background-color: #191a20;
    height: 100%;
    .daochu {
      display: none;
    }
    .tablelisttwo {
      display: none;
    }
    .tablelist {
      .el-table .warning-row {
        background: #202023;
        color: #b1b1b1;
      }
      .el-table .warning-row3 {
        background: #393a43;
        color: #c5c5c5;
      }
    }
    .returnn {
      width: 100%;
      height: 75px;
      margin: auto;
      position: relative;
      img {
        position: absolute;
        top: 8.7rem;
        left: 12rem;
      }
      span {
        position: absolute;
        top: 7.5rem;
        left: 20rem;
        font-size: 16px;
        color: #1eb9ee;
      }
    }
    .Record_details {
      width: 100%;
      height: 240rem;
      background-color: #282931;
      margin: auto;
      position: relative;
      .medical_name {
        font-size: 18px;
        color: #fff;
        position: absolute;
        top: 7.9rem;
        left: 18rem;
      }
      .qian {
        position: absolute;
        top: 31px;
        left: 46px;
      }
      .Record_img {
        width: 100rem;
        height: 80rem;
        position: absolute;
        top: 83px;
        left: 5rem;
        img {
          width: 110rem;
          height: 80rem;
        }
      }
      .Record_score {
        width: 95%;
        height: 374px;
        background-color: #36373f;
        position: absolute;
        top: 120rem;
        right: 3rem;
        .scorename {
          width: 385px;
          height: 46px;
          position: absolute;
          top: 17px;
          right: 30px;
          color: #fff;
          font-size: 16px;
          line-height: 46px;
          text-align: center;
          // border-bottom: 1px solid #5a5b66;
        }
        .score1 {
          position: absolute;
          top: 129px;
          left: 55px;
          color: #fff;
        }
        .score2 {
          position: absolute;
          top: 171px;
          left: 55px;
          color: #fff;
        }
        .score3 {
          position: absolute;
          top: 209px;
          left: 55px;
          color: #fff;
        }
        .score4 {
          position: absolute;
          top: 252px;
          left: 55px;
          color: #fff;
        }
        .score5 {
          position: absolute;
          top: 294px;
          left: 55px;
          color: #fff;
        }
        .score7 {
          height: 170px;
          width: 170px;
          position: absolute;
          top: 155px;
          right: 30px;
          display: flex;
          justify-content: center;
          .score6 {
            line-height: 170px;
            color: #fff;
            z-index: 1000;
            font-size: 30px;
          }
          img {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
    .Details_page {
      height: 65px;
      width: 100%;
      background-color: #2f3037;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      left: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }
    .el-pagination {
      margin: auto;
    }
  }
}
@media screen and (min-width: 768px) {
  .warning-row {
    background-color: @bg1;
    color: @writing1;
  }
  .success-row {
    background-color: @bg3;
    color: @writing;
  }
  .box-tabs-ul {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .box-tabs-table-body {
      width: 1220px;
      .box-tabs-table {
        width: 1220px;
        .box-tabs-table-head {
          width: 1220px;
          display: flex;
          justify-content: space-around;
          color: @writing1;
          font-weight: 700;
          font-size: 16px;
          background-color: @bg1;
          height: 50px;
          align-items: center;
        }
        .box-tabs-table-ul {
          width: 1220px;
          display: flex;
          justify-content: space-around;
          font-weight: 700;
          font-size: 16px;
          height: 50px;
          align-items: center;
        }
        .box-tabs-table-ul:hover {
          background-color: #393a43;
        }
      }
    }
  }
  .practibox {
    background-color: @bg3;
    height: 100%;
    .tablelisttwo {
      display: none;
    }
    .tablelist {
      background-color: @bg2;
      .el-table::before {
        background: @bg1;
      }
      .el-table .warning-row {
        background: @bg1;
        color: @writing1;
      }
      .el-table .warning-row3 {
        background: @bg3;
        color: @writing;
      }
    }
    .returnn {
      width: 1219px;
      height: 75px;
      margin: auto;
      position: relative;
      img {
        position: absolute;
        top: 30px;
        left: 0;
      }
      span {
        position: absolute;
        top: 25px;
        left: 30px;
        font-size: 16px;
        color: #1eb9ee;
      }
    }
    .Record_details {
      width: 1220px;
      height: 486px;
      background-color: @bg2;
      margin: auto;
      position: relative;
      .medical_name {
        font-size: 24px;
        color: @writing;
        position: absolute;
        top: 23px;
        left: 64px;
      }
      .qian {
        position: absolute;
        top: 31px;
        left: 46px;
      }
      .Record_img {
        width: 664px;
        height: 374px;

        position: absolute;
        top: 83px;
        left: 46px;
        img {
          width: 664px;
          height: 374px;
        }
      }
      .Record_score {
        width: 450px;
        height: 374px;
        background-color: @bg1;
        position: absolute;
        top: 83px;
        right: 33px;
        .scorename {
          width: 385px;
          height: 46px;
          position: absolute;
          top: 17px;
          right: 30px;
          color: @writing;
          font-size: 16px;
          line-height: 46px;
          text-align: center;
          border-bottom: 1px solid #5a5b66;
        }
        .score1 {
          position: absolute;
          top: 129px;
          left: 55px;
          color: @writing;
        }
        .score2 {
          position: absolute;
          top: 171px;
          left: 55px;
          color: @writing;
        }
        .score3 {
          position: absolute;
          top: 209px;
          left: 55px;
          color: @writing;
        }
        .score4 {
          position: absolute;
          top: 252px;
          left: 55px;
          color: @writing;
        }
        .score5 {
          position: absolute;
          top: 294px;
          left: 55px;
          color: @writing;
        }
        .score7 {
          height: 170px;
          width: 170px;
          position: absolute;
          top: 155px;
          right: 30px;
          display: flex;
          justify-content: center;
          .score6 {
            line-height: 170px;
            color: #fff;
            z-index: 1000;
            font-size: 30px;
          }
          img {
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }
    }
    .Details_page {
      height: 65px;
      width: 100%;
      background-color: #2f3037;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      left: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }
    .el-pagination {
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/PracticeDetail.vue